import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'src/ui'
import ConfigPanel from 'src/companies/configurations/config-panel'
import { Dispatch } from 'src/store'
import { getPortalBaseUrl } from 'src/utils'

// PANEL
/////////////////////////////////////////////////////////////////////
type AdminUsersPanelProps = {
  company: Company
}

const AdminUsersPanel: React.FC<AdminUsersPanelProps> = ({ company }) => {
  return (
    <>
      <ConfigPanel
        label="Admin Users"
        expanded={false}
        editPermission="company_config_edit"
        panelState={'collapsed'}
        hideToggleIcon
        controls={
          <Button
            as="a"
            href={`${getPortalBaseUrl()}/${company.slug}/staff/team-access`}
            size="sm"
            colorScheme="secondary"
            target="_blank"
          >
            Go to new team access UI
          </Button>
        }
      />
    </>
  )
}

const mapDispatch = ({ notifications }: Dispatch) => ({
  errorNotification: notifications.createError,
  successNotification: notifications.createSuccess,
})

export default connect(
  null, // mapState
  mapDispatch
)(AdminUsersPanel)
